
export enum PaymentUiState {
    MAKE_PAYMENT = "makePayment",
    SCHEDULE_PAYMENT = "schedulePayment",
    AMENITY_PAYMENT = "amenityPayment"
}
